import { ArrowUpRight, Check } from "lucide-react";
import { Overline, Reveal } from "./Reveal";
import { waLink, WA_MESSAGES } from "../config/site";
import { trackEvent } from "../lib/analytics";

const BENEFITS = [
  "Site profissional para transmitir confiança",
  "Presença digital estruturada",
  "Campanhas orientadas por objetivos",
  "Mensuração de contatos e oportunidades",
  "Integração com WhatsApp",
  "Estratégias adaptadas à realidade de cada negócio",
];

export const LocalBusiness = () => (
  <section id="negocios-locais" data-testid="local-business-section" className="relative py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-12">
      <div>
        <Reveal>
          <Overline>Negócios locais</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl">
            Sua empresa pode ser a <span className="chrome-text">próxima escolha</span> do seu cliente.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-gb-gray sm:text-lg">
            Fortaleça sua presença digital, apresente seus diferenciais e crie caminhos mais simples
            para que as pessoas encontrem sua empresa e entrem em contato.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <ul className="mt-9 space-y-4">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm text-gb-silver sm:text-base">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-gb-silver/30 bg-white/[0.03]">
                  <Check className="h-3 w-3 text-gb-silverhi" aria-hidden="true" />
                </span>
                {b}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.3}>
          <a
            href={waLink(WA_MESSAGES.local)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("whatsapp_click", { location: "local_business" })}
            data-testid="local-business-cta"
            className="btn-chrome mt-10 inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm font-semibold"
          >
            Vamos conversar sobre seu negócio
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="card-glass overflow-hidden p-2">
          <img
            src="/assets/capa.jpg"
            alt="Capa institucional GOBAX — Tráfego Pago e Performance Digital"
            width={1600}
            height={595}
            loading="lazy"
            className="w-full rounded-xl object-cover transition-transform duration-700 hover:scale-[1.02]"
          />
        </div>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-gb-gray/70">
          Clínicas · Studios · Consultórios · Lojas · Serviços
        </p>
      </Reveal>
    </div>
  </section>
);
